<template>
  <div class="team-wrap">
    <div class="team-avatar">
      <account-avatar :account="imActiveTeam" width="100px" height="100px" font-size="50px" />
      <span>{{ imActiveTeam.name }}</span>
    </div>
    <div>
      <el-button type="primary" size="mini" @click="createSession">进入群聊</el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AccountAvatar from '../../AccountAvatar.vue'
export default {
  name: 'TeamWrap',
  components: { AccountAvatar },
  props: {
    imActiveTeam: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      imSessions: state => state.imSessions,
      imSessionMap: state => state.imSessionMap
    }),
    nickName () {
      return this.imActiveTeam.name ? this.imActiveTeam.name : ''
    }
  },
  watch: {
  },
  methods: {
    ...mapActions(['addSession', 'loadMoreMsgOfSession', 'fetchTeamInfo']),
    createSession () {
      this.addSession({ account: this.imActiveTeam.teamId, scene: 'team' })
      this.fetchTeamInfo(this.imActiveTeam.teamId)
      // this.loadMoreMsgOfSession({ scene: 'team', to: this.imActiveTeam.teamId, limit: 10, messageListScrollTot: 'bottom' })
    }
  }
}
</script>

<style lang="stylus" scoped>
.team-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 100px;
  flex: 1;
}
.team-avatar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/common/im/team/list/TeamWrap.vue